import React from "react";
import { DataViewGrid } from "../../../shared/components/DataView";
import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import { mapInsuranceCoverageToDataView } from "../../Requirements/modules/SharedFile/configs/helpers/mapInsuranceCoverageToDataView";

export const InsuranceCoverageDataView: React.FC<{
  insuranceCoverage: insuranceCoverageApiSpec.InsuranceCoverage;
}> = ({ insuranceCoverage }) => {
  return (
    <DataViewGrid
      data={mapInsuranceCoverageToDataView(insuranceCoverage)}
      fullWidth={false}
      gridColumns={3}
    />
  );
};
